module.exports = __webpack_public_path__ + "static/media/influencer-icon.b97de40a.png";